export enum AccountLocatorRuleType {
Normal,
Composite,
}
